export const errors: {[key: string]: string} = {
    "occupied_time": "This time is taken, choose another time"
}